import styled from 'styled-components';

export const ContentStyled = styled.div`
  padding: 3.2rem 7.2rem 4.8rem;
  margin: 0;
  min-height: 100vh;
`;
